module.exports = __webpack_public_path__ + "img/preview-delivery.6b63e786.svg";